module.exports = __webpack_public_path__ + "img/m-fapiaochaxun.07743c62.svg";